<template>

<div class="main help-center">
    <router-view v-if="loading.length == 0" />
    <loading class="full-page" v-else></loading>
</div>

</template>

<script>
import { mapGetters, mapActions } from "vuex"
export default {
    name: 'help-center',
    data() {
        return {
            loading: [],
            token: ''
        }
    },
    created() {
        // enable token in query string (e.g. from FFL Office)
        const urlParams = new URLSearchParams(window.location.search);
        let urlToken = urlParams.get('fd_token')
        this.token = urlToken || this.$route.query.fd_token
        console.log(this.$route)
        //if (!this.token) {
        //   this.$router.push({ name: 'Login' })
        //}
        this.bootstrap()
    },
    methods: {
        ...mapActions('dashboard_module', [
            'constructFlatList',
            'updateSearchKbItems',
            'updateKBMenu'
        ]),
        bootstrap() {
            this.loading.push('get_list_search_kb_items')
            this.loading.push('get_kb_menu')
            this.apiCall({ destination: 'get_list_search_kb_items', data: { fd_token: this.token } }).then(obj => {
                if (obj.status == 'success') {
                    this.loading.splice(this.loading.indexOf('get_list_search_kb_items'), 1)
                    this.updateSearchKbItems(obj.search_kb_items)
                    this.apiCall({ destination: 'get_kb_menu', data: { fd_token: this.token } }).then(obj => {
                        this.loading.splice(this.loading.indexOf('get_kb_menu'), 1)
                        this.updateKBMenu(obj.kb_menu)
                        this.constructFlatList(obj.kb_menu)
                    }).catch(err => {
                        this.loading.splice(this.loading.indexOf('get_kb_menu'), 1)
                        console.log(err);
                    })
                } else {
                    this.$router.push({ name: 'Login' })
                }
            }).catch(err => {
                this.loading.splice(this.loading.indexOf('get_list_search_kb_items'), 1)
                console.log(err);
            })
        }
    }
}
</script>

<style>

</style>
